// extracted by mini-css-extract-plugin
export default {"content":"Modesmotry_content__MdKYk","title":"Modesmotry_title__4Bi4S"};